<!-- components/addevent.vue work as a dialog on dashboard open via button -->
<template>
  <v-main class="py-0">
    <v-container fluid>
      <h4>Add event</h4>
      <v-row justify="center" class="mt-5" wrap>
        <v-col xs="12" sm="12" md="12" lg="12" style="margin-bottom: 1em; height: auto" class="calendar-text">
          <v-form @submit.prevent="submitForm">
            <!-- Use @submit.prevent for form submissionจ -->
            <v-row justify="start" wrap>
              <v-col cols="12" md="4" sm="8">
                <v-text-field v-model="formData.bookBy" label="ชื่อผู้จอง" required readonly="true"
                  variant="outlined"></v-text-field>
              </v-col>
              <!--  -->
              <v-col cols="12" md="4" sm="4">
                <v-select v-model="formData.status" :items="user_role" label="* จองในถานะ" required variant="outlined"
                  class="text-red"></v-select>
              </v-col>
              <v-col cols="12" md="4" sm="8">
                <v-text-field v-model="formData.number" label="จำนวนผู้ใช้งาน" variant="outlined" width="50%"
                  type="number" min="0"></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="4" sm="8">
                <v-text-field color="red" v-model="formData.advisor" :disabled="formData.status !== 'นักศึกษา'"
                  label="อาจารย์ประจำกลุ่ม" variant="outlined" persistent-hint hint="สำหรับนักศึกษา"></v-text-field>
              </v-col>
              <v-col cols="12" md="3" sm="5">
                <v-text-field v-model="formData.tel" label="เบอร์โทร" variant="outlined" width="100%"
                  class="text-red"></v-text-field>
              </v-col>
              <v-col cols="12" md="3" sm="5">
                <v-select label="วัตถุประสงค์การใช้ห้อง" :items="['Skill', 'Sim', 'OSCE', 'Self Study', 'อื่นๆ']"
                  v-model="formData.purpose" multiple variant="outlined" persistent-hint hint="ถ้าเลือกอื่นๆ จะเลือกได้อย่างเดียว"
                  class="text-red"></v-select>
              </v-col>
              <v-col cols="12" md="2" sm="12" v-if="formData.purpose.includes('อื่นๆ')">
                <v-text-field v-model="otherPurpose" label="ระบุวัตถุประสงค์อื่นๆ" variant="outlined"
                  class="text-red"></v-text-field>
              </v-col>
            </v-row>
            <!--  -->
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-date-input
                  label="* ตั้งแต่วันที่"
                  variant="outlined"
                  prepend-icon=""
                  prepend-inner-icon="$calendar"
                  v-model="formData.startDate"
                  class="text-red date-picker-field"
                ></v-date-input>
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-date-input
                  label="* จนถึงวันที่"
                  variant="outlined"
                  prepend-inner-icon="$calendar"
                  v-model="formData.endDate"
                  class="text-red date-picker-field"
                ></v-date-input>
              </v-col>
            </v-row>
            <!--  -->
            <v-row justify="space-start">
              <v-col cols="12" sm="5" md="4">
                <v-text-field v-model="formData.startTime" variant="outlined" :active="menu2" label="ตั้งแต่เวลา"
                  prepend-icon="mdi-clock-time-four-outline" readonly :disabled="allday" persistent-hint
                  hint="กรณีจองทั้งวัน ไม่ต้องกรอกเวลา">
                  <v-menu v-model="menu2" :close-on-content-click="false" activator="parent"
                    transition="scale-transition">
                    <v-time-picker v-if="menu2" v-model="formData.startTime" full-width format="24hr"></v-time-picker>
                  </v-menu>
                </v-text-field>
              </v-col>
              <!--  -->
              <v-col cols="12" sm="5" md="4">
                <v-text-field v-model="formData.endTime" :active="menu3" label="ถึงเวลา"
                  prepend-icon="mdi-clock-time-four-outline" readonly :disabled="allday" variant="outlined">
                  <v-menu v-model="menu3" :close-on-content-click="false" activator="parent"
                    transition="scale-transition">
                    <v-time-picker v-if="menu3" v-model="formData.endTime" full-width format="24hr"></v-time-picker>
                  </v-menu>
                </v-text-field>
              </v-col>
              <v-checkbox v-model="allday" label="ทั้งวัน"></v-checkbox>
            </v-row>

            <!--  -->
            <v-row>
              <v-col cols="12" md="4">
                <v-select class="text-red" v-model="formData.Room" :items="availableRoom" label="* ห้องที่ต้องการจอง"
                  variant="outlined" required :loading="isLoading"
                  :error-messages="error ? error.message : ''"></v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-textarea label="หมายเหตุ" row-height="10" rows="1" auto-grow variant="outlined" color="pink"
                  v-model="formData.note" persistent-hint hint=""></v-textarea>
              </v-col>
              <v-col cols="12" md="4">
                <v-textarea row-height="10" rows="1" auto-grow v-model="formData.sNote" label="รายละเอียดวัตถุประสงค์"
                  variant="outlined" class="text-red"></v-textarea>
              </v-col>
            </v-row>
            <v-col cols="12" md="4">
              <div v-if="
                formData.Room === '1421 : ห้องบงกช 1' ||
                formData.Room === '1422 : ห้องบงกช 2' ||
                formData.Room === '1423 : ห้องบงกช 3'
              ">
                <v-alert type="warning" variant="tonal" class="mt-3">
                  <v-icon class="mr-2">mdi-alert</v-icon>
                  ห้อง {{ formData.Room }} มีการจองที่จำกัด
                  กรุณาตรวจสอบกับเจ้าหน้าที่ก่อนทำการจอง
                </v-alert>
              </div>
            </v-col>
            <v-btn color="primary" type="submit" :disabled="isFormInvalid">Submit</v-btn>
            <!-- Changed to type="submit" -->
          </v-form>
        </v-col>
      </v-row>

      <!-- Add this dialog to your addevent.vue template, after your existing form -->

      <!-- Booking Confirmation Dialog -->
      <v-dialog v-model="showConfirmDialog" max-width="700" persistent style="overflow: hidden">
        <v-card class="elevation-12">
          <v-card-title class="headline text-primary pa-6">
            <v-icon class="mr-3" size="28">mdi-calendar-check</v-icon>
            ยืนยันการจองห้อง
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text class="pa-6">
            <v-alert type="info" variant="tonal" class="mb-6">
              <v-icon class="mr-2">mdi-information</v-icon>
              กรุณาตรวจสอบข้อมูลการจองให้ถูกต้องก่อนยืนยัน
            </v-alert>

            <div class="booking-summary">
              <div class="summary-section mb-4">
                <h3 class="text-h6 mb-3 text-primary">
                  <v-icon class="mr-2">mdi-account</v-icon>
                  ข้อมูลผู้จอง
                </h3>
                <v-row class="booking-detail-row">
                  <v-col cols="6">
                    <div class="detail-item">
                      <span class="detail-label">ชื่อผู้จอง:</span>
                      <span class="detail-value">{{ formData.bookBy }}</span>
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div class="detail-item">
                      <span class="detail-label">สถานะ:</span>
                      <v-chip :color="getStatusColor(formData.status)" size="small" variant="elevated">
                        {{ formData.status }}
                      </v-chip>
                    </div>
                  </v-col>
                </v-row>
                <v-row class="booking-detail-row" v-if="formData.advisor">
                  <v-col cols="6">
                    <div class="detail-item">
                      <span class="detail-label">อาจารย์ประจำกลุ่ม:</span>
                      <span class="detail-value">{{ formData.advisor }}</span>
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div class="detail-item">
                      <span class="detail-label">เบอร์โทร:</span>
                      <span class="detail-value">{{ formData.tel }}</span>
                    </div>
                  </v-col>
                </v-row>
              </div>

              <v-divider class="my-4"></v-divider>

              <div class="summary-section mb-4">
                <h3 class="text-h6 mb-3 text-primary">
                  <v-icon class="mr-2">mdi-door</v-icon>
                  ข้อมูลห้องและการใช้งาน
                </h3>
                <v-row class="booking-detail-row">
                  <v-col cols="12">
                    <div class="detail-item">
                      <span class="detail-label">ห้องที่จอง:</span>
                      <v-chip color="success" size="large" variant="elevated" class="ml-2">
                        <v-icon class="mr-1">mdi-door</v-icon>
                        {{ formData.Room }}
                      </v-chip>
                    </div>
                  </v-col>
                </v-row>
                <v-row class="booking-detail-row" v-if="formData.number">
                  <v-col cols="6">
                    <div class="detail-item">
                      <span class="detail-label">จำนวนผู้ใช้งาน:</span>
                      <span class="detail-value">{{ formData.number }} คน</span>
                    </div>
                  </v-col>
                  <v-col cols="6" v-if="formData.purpose && formData.purpose.length > 0">
                    <div class="detail-item">
                      <span class="detail-label">วัตถุประสงค์:</span>
                      <div class="mt-1">
                        <v-chip v-for="purpose in formData.purpose" :key="purpose" size="small" color="info"
                          variant="tonal" class="mr-1 mb-1">
                          {{ purpose }}
                        </v-chip>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </div>

              <v-divider class="my-4"></v-divider>

              <div class="summary-section mb-4">
                <h3 class="text-h6 mb-3 text-primary">
                  <v-icon class="mr-2">mdi-clock</v-icon>
                  ช่วงเวลาการจอง
                </h3>
                <div class="time-summary-card">
                  <v-row class="booking-detail-row">
                    <v-col cols="6">
                      <div class="detail-item">
                        <span class="detail-label">วันที่เริ่มต้น:</span>
                        <span class="detail-value">{{
                          formatDate(formData.startDate)
                        }}</span>
                      </div>
                    </v-col>
                    <v-col cols="6">
                      <div class="detail-item">
                        <span class="detail-label">วันที่สิ้นสุด:</span>
                        <span class="detail-value">{{
                          formatDate(formData.endDate)
                        }}</span>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row class="booking-detail-row">
                    <v-col cols="12">
                      <div class="detail-item">
                        <span class="detail-label">ช่วงเวลา:</span>
                        <v-chip :color="allday ? 'purple' : 'orange'" variant="elevated" size="large" class="ml-2">
                          <v-icon class="mr-1">
                            {{
                              allday
                                ? "mdi-calendar-clock"
                                : "mdi-clock-outline"
                            }}
                          </v-icon>
                          {{
                            allday
                              ? "ทั้งวัน (09:00 - 17:00)"
                              : `${formData.startTime} - ${formData.endTime}`
                          }}
                        </v-chip>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div>

              <div class="summary-section" v-if="formData.note">
                <v-divider class="my-4"></v-divider>
                <h3 class="text-h6 mb-3 text-primary">
                  <v-icon class="mr-2">mdi-note-text</v-icon>
                  หมายเหตุ
                </h3>
                <div class="note-card">
                  <p class="text-body-1 mb-0">{{ formData.note }}</p>
                </div>
              </div>
            </div>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="pa-6">
            <v-btn color="grey-darken-1" variant="outlined" size="large" @click="cancelConfirmBooking">
              <v-icon class="mr-2">mdi-arrow-left</v-icon>
              แก้ไขข้อมูล
            </v-btn>

            <v-spacer></v-spacer>

            <v-btn color="primary" variant="elevated" size="large" @click="proceedToOverlapCheck"
              :loading="isSubmitting">
              <v-icon class="mr-2">mdi-check-circle</v-icon>
              ยืนยันการจอง
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Overlap Confirmation Dialog -->
      <v-dialog v-model="showOverlapDialog" max-width="600" persistent>
        <v-card>
          <v-card-title class="headline text-orange-darken-2">
            <v-icon class="mr-2">mdi-alert-circle</v-icon>
            พบการจองที่ทับซ้อน!
          </v-card-title>

          <v-card-text class="py-4">
            <v-alert type="warning" class="mb-4">
              มีการจองห้องในช่วงเวลาที่ทับซ้อนกับการจองของคุณ
            </v-alert>

            <div class="overlap-details">
              <pre class="text-body-2">{{ overlapMessage }}</pre>
            </div>

            <div class="mt-4">
              <strong>คุณต้องการดำเนินการจองต่อไปหรือไม่?</strong>
              <div class="text-caption mt-1 text-red">
                หมายเหตุ: การจองที่ทับซ้อนอาจทำให้เกิดปัญหาในการใช้งานห้อง
              </div>
            </div>
          </v-card-text>

          <v-card-actions class="px-6 pb-4">
            <v-btn color="orange-darken-2" variant="elevated" @click="cancelOverlapBooking">
              <v-icon class="mr-1">mdi-cancel</v-icon>
              ยกเลิกการจอง
            </v-btn>

            <v-spacer></v-spacer>

            <v-btn disabled="true" color="grey-darken-2" variant="elevated" @click="confirmOverlapBooking">
              ใช้วันหรือเวลาอื่น
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script setup>
/// Updated script section for addevent.vue
// Add this to your existing script setup

import { ref, onMounted, computed, watch, defineEmits } from "vue";
import "../css/main.css";
import { db } from "@/firebaseConfig";
import { addDoc, collection } from "firebase/firestore";
import { useAuth } from "@/composable";
import { useroom } from "@/useroom";
import { useNurseData } from "@/useNurseData"; // Add this import
import {
  checkRoomOverlap,
  generateConflictMessage,
} from "@/utils/overlapChecker"; // Add this import
import Swal from 'sweetalert2';

const { user } = useAuth();
const { roomItems, isLoading, error } = useroom();
const { nurseItems } = useNurseData(); // Add this to get existing bookings
const emit = defineEmits(["close-dialog"]);

const allday = ref(false);
const menu2 = ref(false);
const menu3 = ref(false);
const showConfirmDialog = ref(false); // Add this for booking confirmation dialog
const showOverlapDialog = ref(false); // Add this for overlap confirmation dialog
const overlapMessage = ref(""); // Add this for overlap message
const pendingBookingData = ref(null); // Add this to store booking data when overlap is detected
const isSubmitting = ref(false); // Add loading state
const invalidroom = ref(false); // Add this to track invalid room selection

const formData = ref({
  bookBy: "",
  bId: "",
  Room: "",
  status: "",
  startDate: "",
  endDate: "",
  startTime: null,
  endTime: null,
  note: "",
  advisor: "",
  tel: "",
  purpose: [],
  sNote: "",
  number: 1,
});

const user_role = ref(["อาจารย์", "นักศึกษา", "บุคลากร"]);
const otherPurpose = ref("");

const availableRoom = computed(() => {
  return roomItems.value
    .filter((room) => room.available === true)
    .map((room) => `${room.id} : ${room.rName}`);
});

const isFormInvalid = computed(() => {
  if (
    !formData.value.status ||
    !formData.value.Room ||
    !formData.value.tel ||
    !formData.value.purpose || formData.value.purpose.length === 0 ||
    (formData.value.purpose.includes('อื่นๆ') && !otherPurpose.value.trim()) ||
    !formData.value.startDate ||
    !formData.value.endDate ||
    !formData.value.sNote
  ) {
    return true;
  }

  if (
    formData.value.Room === "1421 : ห้องบงกช 1" ||
    formData.value.Room === "1422 : ห้องบงกช 2" ||
    formData.value.Room === "1423 : ห้องบงกช 3" ||
    formData.value.Room === "1413 : ห้องปฏิบัติการพยาบาลหุ่นเสมือนจริงหญิงตั้งครรภ์" ||
    formData.value.Room === "1414 : ห้องปฏิบัติการพยาบาลหุ่นเสมือนจริงผู้ใหญ่"
  ) {
    return true;
  }

  if (formData.value.status === "นักศึกษา" && !formData.value.advisor) {
    return true;
  }

  if (!allday.value && (!formData.value.startTime || !formData.value.endTime)) {
    return true;
  }

  if (!formData.value.bookBy || !formData.value.bId) {
    return true;
  }

  if (formData.value.startDate && formData.value.endDate) {
    const start = new Date(formData.value.startDate);
    const end = new Date(formData.value.endDate);
    if (start > end) {
      return true;
    }
  }

  return false;
});

onMounted(() => {
  if (user.value) {
    formData.value.bookBy = user.value.name || "";
    formData.value.bId = user.value.uid || "";
  }
});

// Real-time validations to alert users immediately
watch([() => formData.value.startDate, () => formData.value.endDate], ([newStart, newEnd]) => {
  if (newStart && newEnd) {
    const start = new Date(newStart);
    const end = new Date(newEnd);
    if (start > end) {
      Swal.fire({ text: "วันที่สิ้นสุดต้องไม่อยู่ก่อนวันที่เริ่มต้น", icon: 'warning' });
      // Clear the invalid end date to prevent submission
      formData.value.endDate = null;
    }
  }
});

watch(() => formData.value.Room, (newRoom) => {
  if (!newRoom) return;
  if (
    newRoom === "1421 : ห้องบงกช 1" ||
    newRoom === "1422 : ห้องบงกช 2" ||
    newRoom === "1423 : ห้องบงกช 3"
  ) {
    Swal.fire({ text: "ห้องนี้มีการจองที่จำกัด กรุณาติดต่อเจ้าหน้าที่สำนักงานคณบดีในการทำการจอง", icon: 'warning' });
  } else if (
    newRoom === "1413 : ห้องปฏิบัติการพยาบาลหุ่นเสมือนจริงหญิงตั้งครรภ์" ||
    newRoom === "1414 : ห้องปฏิบัติการพยาบาลหุ่นเสมือนจริงผู้ใหญ่"
  ) {
    Swal.fire({ text: "กรุณาติดต่อสำนักงานคณบดีเพื่อทำการจองห้องนี้", icon: 'warning' });
  }
});

watch(() => formData.value.purpose, (newVal) => {
  if (newVal && newVal.includes('อื่นๆ')) {
    if (newVal.length > 1) {
      if (newVal[newVal.length - 1] === 'อื่นๆ') {
        formData.value.purpose = ['อื่นๆ'];
      } else {
        formData.value.purpose = newVal.filter(item => item !== 'อื่นๆ');
      }
    }
  }
});

// Updated submitForm function to show confirmation dialog first
const submitForm = () => {
  // Basic validation first
  if (
    !formData.value.status ||
    !formData.value.Room ||
    !formData.value.tel ||
    !formData.value.purpose ||
    !formData.value.startDate ||
    !formData.value.endDate ||
    !formData.value.sNote
  ) {
    Swal.fire({ text: "กรุณากรอกข้อมูลให้ครบถ้วน", icon: 'warning' });
    return;
  }
  if (
    formData.value.Room === "1421 : ห้องบงกช 1" ||
    formData.value.Room === "1422 : ห้องบงกช 2" ||
    formData.value.Room === "1423 : ห้องบงกช 3"
  ) {
    Swal.fire({ text: "ห้องนี้มีการจองที่จำกัด กรุณาติดต่อเจ้าหน้าที่สำนักงานคณบดีในการทำการจอง", icon: 'warning' });
    return;
  }
  if (formData.value.status === "นักศึกษา") {
    if (!formData.value.advisor) {
      Swal.fire({ text: "(นักศึกษา) กรุณากรอกข้อมูล อาจารย์ประจำกลุ่ม และ หมายเหตุสำหรับนักศึกษา", icon: 'warning' });
      return;
    }
  }

  if (!allday.value) {
    if (!formData.value.startTime || !formData.value.endTime) {
      Swal.fire({ text: "กรุณากรอกเวลาเริ่มและเวลาสิ้นสุด", icon: 'warning' });
      return;
    }
  }

  if (!formData.value.bookBy || !formData.value.bId) {
    Swal.fire({ text: "กรุณาลองอีกครั้ง", icon: 'error' });
    return;
  }

  if (
    formData.value.Room === "1413 : ห้องปฏิบัติการพยาบาลหุ่นเสมือนจริงหญิงตั้งครรภ์" ||
    formData.value.Room === "1414 : ห้องปฏิบัติการพยาบาลหุ่นเสมือนจริงผู้ใหญ่"
  ) {
    Swal.fire({ text: "กรุณาติดต่อสำนักงานคณบดีเพื่อทำการจองห้องนี้", icon: 'warning' });
    return;
  }

  if (formData.value.startDate > formData.value.endDate) {
    Swal.fire({ text: "วันที่สิ้นสุดต้องไม่อยู่ก่อนวันที่เริ่มต้น", icon: 'warning' });
    return;
  }

  // Show confirmation dialog after validation passes
  showConfirmDialog.value = true;
};

// New function to proceed after user confirms booking details
const proceedToOverlapCheck = () => {
  isSubmitting.value = true;
  showConfirmDialog.value = false;

  let startDateTime, endDateTime;

  if (allday.value) {
    startDateTime = mergeDateTime(formData.value.startDate, "09:00");
    endDateTime = mergeDateTime(formData.value.endDate, "17:00");
  } else {
    startDateTime = mergeDateTime(
      formData.value.startDate,
      formData.value.startTime
    );
    endDateTime = mergeDateTime(formData.value.endDate, formData.value.endTime);
  }

  if (formData.value.status !== "นักศึกษา") {
    formData.value.advisor = "";
  }

  // Create booking data object
  const bookingData = {
    ...formData.value,
    startDate: startDateTime,
    endDate: endDateTime,
    purpose: formData.value.purpose.map(p => p === 'อื่นๆ' ? `อื่นๆ: ${otherPurpose.value}` : p)
  };

  // Check for overlaps
  checkForOverlaps(bookingData);
};

// New function to cancel confirmation dialog
const cancelConfirmBooking = () => {
  showConfirmDialog.value = false;
};

// New function to check for overlaps
const checkForOverlaps = (bookingData) => {
  // Check for room overlap
  const overlapResult = checkRoomOverlap(bookingData, nurseItems.value);

  if (overlapResult.error) {
    isSubmitting.value = false;
    Swal.fire({ text: `เกิดข้อผิดพลาด: ${overlapResult.error}`, icon: 'error' });
    return;
  }

  if (overlapResult.hasOverlap) {
    // Show overlap confirmation dialog
    overlapMessage.value = generateConflictMessage(
      overlapResult.conflictingBookings,
      overlapResult.roomId
    );
    pendingBookingData.value = bookingData;
    showOverlapDialog.value = true;
    isSubmitting.value = false;
  } else {
    // No overlap, proceed with booking
    proceedWithBooking(bookingData);
  }
};

// New function to handle confirmed booking (with or without overlap)
const proceedWithBooking = async (bookingData) => {
  try {
    await addDoc(collection(db, "booking"), {
      bookBy: bookingData.bookBy,
      bId: bookingData.bId,
      room: bookingData.Room,
      status: bookingData.status,
      note: bookingData.note,
      allday: allday.value,
      startDate: bookingData.startDate,
      endDate: bookingData.endDate,
      createAt: new Date(),
      advisor: bookingData.advisor,
      tel: bookingData.tel,
      purpose: bookingData.purpose,
      bookStatus: "active",
      sNote: bookingData.sNote,
      number: bookingData.number,
    });

    Swal.fire({ text: "เพิ่มข้อมูลการจองสำเร็จ!", icon: 'success' });
    emit("close-dialog");

    // Reset form if needed
    // resetForm();
  } catch (e) {
    console.error("Error adding booking to Firestore:", e);
    Swal.fire({ text: "บันทึกข้อมูลไม่สำเร็จ โปรดตรวจสอบและลองใหม่อีกครั้ง", icon: 'error' });
  } finally {
    isSubmitting.value = false;
  }
};

// New function to handle overlap confirmation
const confirmOverlapBooking = () => {
  if (pendingBookingData.value) {
    proceedWithBooking(pendingBookingData.value);
  }
  showOverlapDialog.value = false;
  pendingBookingData.value = null;
  overlapMessage.value = "";
};

// New function to cancel overlap booking
const cancelOverlapBooking = () => {
  showOverlapDialog.value = false;
  pendingBookingData.value = null;
  overlapMessage.value = "";
};

function mergeDateTime(date, time) {
  if (!date) return null;

  const dateObj = new Date(date);

  if (time) {
    const [hours, minutes] = time.split(":").map(Number);
    dateObj.setHours(hours || 0);
    dateObj.setMinutes(minutes || 0);
    dateObj.setSeconds(0);
  } else {
    dateObj.setHours(0, 0, 0, 0);
  }

  return dateObj.toISOString();
}

// Helper function to format date for display
const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toLocaleDateString("th-TH", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

// Helper function to get status color
const getStatusColor = (status) => {
  switch (status) {
    case "อาจารย์":
      return "blue";
    case "นักศึกษา":
      return "green";
    case "บุคลากร":
      return "purple";
    default:
      return "grey";
  }
};

// Note: In <script setup>, all top-level variables, refs, and functions
// are automatically available to the template. No need to export them.
</script>

<style scoped>
/* You can add specific styles for this form component here if needed */
.main {
  padding: 20px;
}
</style>

<style>
.swal2-container {
  z-index: 10000 !important;
}

.v-messages__message {
  color: red !important;
  font-weight: bold;
  opacity: 100%;
}

.v-label {
  font-size: 1em !important;
  /* Adjust this value as needed */
  font-weight: bold;
  opacity: 1 !important;
}

.overlap-details {
  background-color: #fafafa;
  border-radius: 4px;
  padding: 12px;
  border-left: 4px solid #ff9800;
  max-height: 300px;
  overflow-y: auto;
}

.overlap-details pre {
  margin: 0;
  white-space: pre-wrap;
  word-wrap: break-word;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.4;
  color: #424242;
}

.v-dialog .v-card-title {
  font-weight: bold;
  font-size: 1.25rem;
}

/* Optional: Style for the alert icon */
.v-card-title .v-icon {
  color: #ff9800 !important;
}

/* Booking Confirmation Dialog Styles */
.booking-summary {
  max-height: 500px;
  overflow-y: auto;
}

.summary-section {
  margin-bottom: 1rem;
}

.booking-detail-row {
  margin-bottom: 8px;
}

.detail-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.detail-label {
  font-weight: 600;
  color: #1976d2;
  font-size: 0.875rem;
}

.detail-value {
  font-weight: 500;
  color: #424242;
  font-size: 1rem;
}

.time-summary-card {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
  border-left: 4px solid #1976d2;
}

.note-card {
  background: #fff3e0;
  border-radius: 8px;
  padding: 16px;
  border-left: 4px solid #ff9800;
}

.v-card .v-card-title.text-primary {
  background: linear-gradient(135deg, #1976d2 0%, #42a5f5 100%);
  color: white !important;
  margin: 0;
}

.v-card .v-card-title.text-primary .v-icon {
  color: white !important;
}

/* Mobile-friendly date picker improvements */
@media (max-width: 600px) {
  .date-picker-field {
    font-size: 1.05rem !important;
  }

  .date-picker-field .v-field__input {
    font-size: 1.05rem !important;
    min-height: 56px !important;
    padding-top: 14px !important;
    padding-bottom: 14px !important;
  }

  .date-picker-field .v-label {
    font-size: 1rem !important;
  }

  .date-picker-field .v-input__prepend-inner .v-icon,
  .date-picker-field .v-field__prepend-inner .v-icon {
    font-size: 1.5rem !important;
    width: 28px !important;
    height: 28px !important;
  }

  /* Ensure the clear/calendar icon button is easy to tap */
  .date-picker-field .v-field__append-inner .v-btn,
  .date-picker-field .v-field__append-inner .v-icon {
    min-width: 44px !important;
    min-height: 44px !important;
  }
}
</style>



